import { create } from 'zustand';

import { IUserState } from "~/providers/interfaces";
import { USER_STATE } from "~/const";
import { getBrowserLang } from "~/providers/lang";

interface IUserStore {
	user: IUserState;
	userLoad: {
		meLoaded: boolean;
		errorMsg: string;
	};
	setUser: (data: IUserState) => void;
	unsetUser: () => void;
	setUserLoad: (meLoaded: boolean, errorMsg: string) => void;
}

function getDefaultState(): IUserState {
	return {
		...USER_STATE,
		userLanguage: getBrowserLang(),
	};
}

export const userStore = create<IUserStore>(set => ({
	user: getDefaultState(),
	userLoad: {
		meLoaded: false,
		errorMsg: "",
	},
	setUser: data => set(() => ({
		user: {
			...data,
		},
	})),
	unsetUser: () => set(() => ({
		user: getDefaultState(),
	})),
	setUserLoad: (meLoaded: boolean, errorMsg: string) => set(() => ({
		userLoad: {
			meLoaded,
			errorMsg,
		},
	})),
}));
